import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { auth } from '@/lib/firebase'
import { signOut } from 'firebase/auth'
import { AlertTriangle, LogOut } from 'lucide-react'

interface InactiveUserModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const InactiveUserModal = ({ open, onOpenChange }: InactiveUserModalProps) => {
  const handleSignOut = async () => {
    try {
      await signOut(auth)
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[425px]'>
        <DialogHeader className='text-center space-y-4'>
          <div className='flex justify-center'>
            <div className='w-16 h-16 rounded-full bg-red-100 flex items-center justify-center'>
              <AlertTriangle className='w-8 h-8 text-red-600' />
            </div>
          </div>
          <DialogTitle className='text-xl font-semibold text-neutral-900'>Account Inactive</DialogTitle>
          <DialogDescription className='text-sm text-neutral-600'>
            Your account has been deactivated by your administrator. Please contact your admin or manager to restore
            access to the system.
          </DialogDescription>
        </DialogHeader>

        <div className='flex flex-col gap-3 pt-4'>
          <Button
            onClick={handleSignOut}
            variant='outline'
            className='w-full border-red-600 text-red-600 hover:bg-red-50'
          >
            <LogOut className='w-4 h-4 mr-2' />
            Sign Out
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
